import * as yup from "yup";
import { CreateVariantChildFormValues } from "./types";

export const defaultFormValues: CreateVariantChildFormValues = {
  variantParentId: "",
  selectedOptions: [],
  stockNumber: "",
  locationId: "",
};

export const schema = yup.object().shape({
  variantParentId: yup.string().required("Variant is required"),
  stockNumber: yup.string().required("Stock number is required"),
  locationId: yup.string().optional(),
  selectedOptions: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string().required("Name is required"),
        value: yup.string().required("Value is required"),
      })
    )
    .required("Options are required"),
});
